export const getSearchWidgetExpAdConfigVersion = (
  variant: string,
  kvp: number = 26 // default kvp for search-widget-exp set in optimizely
) => {
  return `search-widget-${kvp}-${variant}`
}

export const getNewHomepageExpAdConfigVersion = (
  variant: string,
  kvp: number = 16 // default kvp for writing-assistant-100-percent set in optimizely
) => {
  const controlVariant = 'control'

  return variant === 'test'
    ? `homepage-product-${kvp}-${variant}`
    : `homepage-product-${kvp}-${controlVariant}`
}
